module.exports = __webpack_public_path__ + "img/Inflammation-GBM_10X_WTA.b61e51f4.png";